__turbopack_context__.v({
  "genButton": "ExperienceDescriptionInput-module-scss-module__PKkBFW__genButton",
  "header": "ExperienceDescriptionInput-module-scss-module__PKkBFW__header",
  "label": "ExperienceDescriptionInput-module-scss-module__PKkBFW__label",
  "root": "ExperienceDescriptionInput-module-scss-module__PKkBFW__root",
});
